<template>
  <div id="top">
    <slot />
  </div>
</template>
